import { z } from 'zod/v4';

export const NOTIFICATION_TYPES = [
  'invoice_sending',
  'reminders',
  'formal_notice',
  'legal_case',
  'ai_call',
] as const;

export type NotificationTypes = (typeof NOTIFICATION_TYPES)[number];

export const NotificationTypesSchema = z.enum([...NOTIFICATION_TYPES]);
